var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _path9, _path10, _linearGradient8, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a",
    gradientUnits: "userSpaceOnUse",
    x1: -1364.508,
    y1: -13.591,
    x2: -1363.508,
    y2: -13.591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M54.151 76.298V23.744h92.784l-.22 113.215H54.151V89.857"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a",
    gradientUnits: "userSpaceOnUse",
    x1: 57.763,
    y1: 21.953,
    x2: 75.659,
    y2: 21.953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.013 22.603a7.698 7.698 0 1115.396 0v6.399",
    fill: "none",
    stroke: "url(#SVGID_1_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a",
    gradientUnits: "userSpaceOnUse",
    x1: 123.949,
    y1: 21.953,
    x2: 141.845,
    y2: 21.953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.199 22.603a7.698 7.698 0 1115.396 0v6.399",
    fill: "none",
    stroke: "url(#SVGID_2_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a",
    gradientUnits: "userSpaceOnUse",
    x1: 101.99,
    y1: 21.953,
    x2: 119.886,
    y2: 21.953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.24 22.603a7.698 7.698 0 1115.396 0v6.399",
    fill: "none",
    stroke: "url(#SVGID_3_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a",
    gradientUnits: "userSpaceOnUse",
    x1: 80.031,
    y1: 21.953,
    x2: 97.927,
    y2: 21.953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.281 22.603a7.698 7.698 0 1115.396 0v6.399",
    fill: "none",
    stroke: "url(#SVGID_4_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M66.557 41.827h68.084"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a",
    gradientUnits: "userSpaceOnUse",
    x1: 65.307,
    y1: 68.944,
    x2: 135.891,
    y2: 68.944
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M66.557 68.944h68.084"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a",
    gradientUnits: "userSpaceOnUse",
    x1: 65.307,
    y1: 97.038,
    x2: 135.891,
    y2: 97.038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M66.557 97.039h68.084"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M135.028 124.744V36.293H66.213v88.351h52.395z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M89.756 49.155h7.449l-6.052 6.052s5.38-1.966 6.983 1.862c1.397 2.328-1.397 8.69-8.535 4.035M106.196 48.586s-4.388-.214-4.388 6.849c0 5.137 1.766 6.588 4.655 6.91 3.667-.043 4.655-2.736 4.655-6.91s-1.39-7.063-4.922-6.849zM105.645 76.183s-4.388-.214-4.388 6.849c0 5.137 1.766 6.588 4.655 6.91 3.667-.043 4.655-2.736 4.655-6.91s-1.391-7.064-4.922-6.849zM105.645 103.718s-4.388-.214-4.388 6.849c0 5.137 1.766 6.588 4.655 6.91 3.667-.043 4.655-2.736 4.655-6.91 0-4.174-1.391-7.063-4.922-6.849zM97.222 78.975s.31-2.793-3.724-2.897c-4.035-.103-4.759 5.069-4.345 8.276.414 3.207 1.138 5.69 5.173 5.38s4.138-4.655 2.276-6.621c-1.862-1.966-7.035-1.759-7.138 2.69M89.595 114.398s-.31 2.793 3.724 2.897 4.759-5.069 4.345-8.276c-.414-3.207-1.138-5.69-5.173-5.38-4.035.31-4.138 4.655-2.276 6.621s7.035 1.759 7.138-2.69"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a",
    gradientUnits: "userSpaceOnUse",
    x1: 11.857,
    y1: 83.527,
    x2: 61.633,
    y2: 83.527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_0a40e6790b32e9a043cdf9c58985fa0d81d8762967d9cb010be19119f81f297a)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M13.107 79.024v9.198h31.562v11.115l15.714-16.481-16.097-15.139v11.307z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBalance);
export default __webpack_public_path__ + "static/media/openBalance.49b3f448b29cbddf524ebc40f1eea45d.svg";
export { ForwardRef as ReactComponent };